import { OffersBenefitsComponent } from './offers-benefits.component';
import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ OffersBenefitsComponent });
